export default __webpack_public_path__ + "static/media/32-min.48f0fb4c.png";